import React from 'react'
import Icon from 'components/Icon'
import { Button, Input, TextArea } from '@arnsbogroup/react-voicearchive'
import { Link } from 'react-router-dom'

const ProjectDetailsOverview = ({ project, onEdit }) => {
  return (
    <div className="space-y-4">
      <h1 className="text-gray-400 font-medium text-sm space-x-2">
        <Icon icon={['fas', 'circle-check']} />
        <span>Project summary</span>
        <Link to="./get-free-quote" className="text-primary font-medium">
          Edit
        </Link>
      </h1>
      <p className="w-full overflow-hidden text-sm">
        {project.details.productType} &#183; {project.details.productQuantity}{' '}
        &#183; {project.details.brief.slice(0, 300)}...
      </p>
    </div>
  )
}

export default ProjectDetailsOverview
